<template>
  <form ref="add_vehicle_form" @submit.prevent="addRole">
    <md-card>
      <md-card-header class="md-card-header-icon">
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h4 class="title">
          Add Role
        </h4>
      </md-card-header>
      <md-card-content>
        <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Role Name</span
            ><span style="color:red"> *</span>
          </label> 
          <div class="md-layout-item">
            <validation-provider rules="name" v-slot="{ errors }">
              <md-field class="md-invalid">
                <md-input v-model="role_name" />
                <validation-error :errors="apiValidationErrors.role_name" />
              </md-field>
              <span>{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>
        <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Division</span><span style="color:red">*</span>
          </label>
          <div class="md-layout-item">
            <validation-provider rules="division" v-slot="{ errors }">
            <md-field class="md-invalid">
              <md-select v-model="division_id">
                <md-option v-for="option in options_divisions" :key="option.value" :value="option.id">
                  {{ option.division_name }}
                </md-option>
              </md-select>
              <validation-error :errors="apiValidationErrors.division_id" />
            </md-field>
            <span>{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>
      </md-card-content>
      <md-card-actions>
        <md-button type="submit">
          Add Role
        </md-button>
      </md-card-actions>
    </md-card>
  </form>
</template>

<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";

extend("name", {
  ...required,
  message: "Name field is required",
});
extend("division", {
  ...required,
  message: "Division field is required",
});
export default {
  name: "add-role",

  props: {
    data: Object,
  },

  components: { ValidationError },

  mixins: [formMixin],

  data: () => ({
    division_id: null,
    role_name: null,
    options_divisions: null,
  }),

  created() {
    this.onOpen();
  },

  methods: {

    async onOpen(){
      await this.$store.dispatch("division/list")
      this.options_divisions = await this.$store.getters["division/list"]
    },

    // fungsi add data
    async addRole() {
      const data = {
        type: "roles",
        name: this.role_name,
        division_id: this.division_id,
      };

      try {
        // kirim data ke api
        await this.$store.dispatch("role/add", data);
        // panggil alert success
        await this.$store.dispatch("alerts/success", "Successfully Added.");
        // kembali ke list role 
        await this.$router.push({ name: "List Role" });
      } catch (e) {
        // jika gagal panggil alert error
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong gan"
        );
        this.setApiValidation(e.response.data.errors);
      }
    },
  },
};
</script>
